import { createAction } from "redux-actions";
import { SET_LOYALTY_IS_BENEFIT_AVAILABLE } from "../constants";

const setIsBenefitAvailable = createAction(
  SET_LOYALTY_IS_BENEFIT_AVAILABLE,
  (isBenefitAvailable, benefitType) => ({
    [benefitType]: isBenefitAvailable
  })
);

export default setIsBenefitAvailable;
